/**
 * Cap the activity scroller to the space left under its top edge inside a
 * bounded layout parent (grid row / modal frame).
 *
 * Prefer `boundBottom` from that parent — not `window.innerHeight` alone —
 * so a tall scrollable page cannot push `top` below the viewport and clamp
 * the pane to the min floor (~160px).
 */
export function activityPaneMaxHeightPx(options: {
    top: number;
    boundBottom: number;
    bottomGapPx?: number;
    minPx?: number;
}): number {
    const bottomGapPx = options.bottomGapPx ?? 16;
    const minPx = options.minPx ?? 160;
    return Math.max(minPx, Math.floor(options.boundBottom - options.top - bottomGapPx));
}
